import { apiSlice } from "app/api/apiSlice";


export const companyApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['CurrentCompanyInfo'],
    endpoints: builder => ({
        getMyCompanyInfo: builder.query({
            query: () => 'company/info/current',
            providesTags: ['CurrentCompanyInfo']
        }),

        // EDIT Company
        editCompanyInfo: builder.mutation({
            query: (
                editedCompanyInfo
            ) => ({
                url: 'company/info/current',
                method: 'PUT',
                body: editedCompanyInfo,
                formData: true
            }),
            invalidatesTags: ['CurrentCompanyInfo']
        }),

        getCompanyFileStats: builder.query({
            query: () => 'file/stats'
        }),
    })
})

export const {
    useGetMyCompanyInfoQuery,
    useEditCompanyInfoMutation,
    useGetCompanyFileStatsQuery
} = companyApiSlice